.logoBlackwing {
  display: block;
  margin: 0 auto 0;
  width: 120px;
}
